import { render } from "./addCards.vue?vue&type=template&id=16a0d4da&scoped=true"
import script from "./addCards.vue?vue&type=script&lang=js"
export * from "./addCards.vue?vue&type=script&lang=js"

import "./addCards.vue?vue&type=style&index=0&id=16a0d4da&lang=scss&scoped=true"
import "./addCards.vue?vue&type=style&index=1&id=16a0d4da&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a0d4da"]])

export default __exports__